/* Baby Ninja homepage: live teaser of the newest Collector's Room listings from the YUBZ app proxy (/apps/market).
   Tolerates any missing field and always falls back to a friendly empty state. */
(() => {
  const host = document.querySelector('[data-yb-market-teaser]');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const grid = host.querySelector('[data-yb-market-teaser-grid]');
  const tpl = name => host.querySelector(`template[data-yb-market-teaser-${name}]`);
  const i18n = host.querySelector('[data-yb-market-teaser-i18n]')?.dataset || {};
  const lang = (host.dataset.lang || document.documentElement.lang || 'en').toLowerCase().startsWith('ar') ? 'ar' : 'en';
  const digits = n => lang === 'ar' ? String(n).replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]) : String(n);
  const money = minor => `${digits((Number(minor || 0) / 1000).toFixed(3))} ${i18n.kd || 'KD'}`;
  const photos = l => { let p = l.photos || l.photo_urls || []; if (typeof p === 'string') { try { p = JSON.parse(p); } catch { p = []; } } return (Array.isArray(p) ? p : []).map(x => typeof x === 'string' ? x : (x && (x.url || x.src)) || '').filter(Boolean); };
  const auctionOf = l => l.auction || (l.ends_at ? l : null);
  const isAuction = l => (l.sale_type || (auctionOf(l) ? 'auction' : 'fixed')) === 'auction';
  const ends = l => { const a = auctionOf(l); const v = a && (a.ends_at || a.endsAt); const d = v ? new Date(v) : null; return d && !isNaN(d) ? d : null; };
  const endsLabel = d => {
    const ms = d - Date.now();
    if (ms <= 0) return i18n.ended || 'Ended';
    const h = Math.floor(ms / 36e5), m = Math.floor((ms % 36e5) / 6e4);
    const rel = h >= 24 ? `${digits(Math.floor(h / 24))}${lang === 'ar' ? ' ي' : 'd'} ${digits(h % 24)}${lang === 'ar' ? ' س' : 'h'}` : `${digits(h)}${lang === 'ar' ? ' س' : 'h'} ${digits(m)}${lang === 'ar' ? ' د' : 'm'}`;
    return `${i18n.ends || 'Ends'} ${rel}`;
  };
  const show = name => { const t = tpl(name); grid.replaceChildren(t ? t.content.cloneNode(true) : ''); };
  const render = items => {
    const card = tpl('card');
    if (!card || !items.length) { show('empty'); return; }
    grid.replaceChildren();
    for (const l of items.slice(0, 4)) {
      const node = card.content.cloneNode(true);
      const a = node.querySelector('a');
      a.href = host.dataset.listingUrl + encodeURIComponent(l.id ?? '');
      const title = (lang === 'ar' && l.title_ar) || l.title_en || l.title || '';
      const img = node.querySelector('img'), p = photos(l);
      const photo = node.querySelector('.yb-market-teaser-card__photo');
      const placeholder = () => { img.remove(); photo.textContent = '🃏'; };
      if (p[0]) { img.addEventListener('error', placeholder, { once: true }); img.src = p[0]; img.alt = title; } else placeholder();
      node.querySelector('[data-title]').textContent = title;
      const auction = isAuction(l), au = auctionOf(l) || {};
      node.querySelector(auction ? '[data-badge-auction]' : '[data-badge-fixed]').hidden = false;
      const minor = auction ? (au.current_bid_minor ?? au.start_price_minor ?? l.price_minor) : l.price_minor;
      node.querySelector('[data-price]').textContent = money(minor);
      node.querySelector('[data-price-label]').textContent = auction ? (i18n.currentBid || '') : '';
      const e = auction ? ends(l) : null, el = node.querySelector('[data-ends]');
      if (e) { el.hidden = false; el.textContent = endsLabel(e); el.dateTime = e.toISOString(); }
      grid.append(node);
    }
  };
  let started = false;
  const load = async () => {
    if (started || host.closest('[hidden]')) return;
    started = true;
    try {
      const r = await fetch(host.dataset.endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error(String(r.status));
      const d = await r.json();
      const items = Array.isArray(d) ? d : (d && (d.items || d.listings || d.results)) || [];
      render(items.filter(l => l && (l.status == null || l.status === 'published' || l.status === 'active' || l.status === 'live')));
    } catch { show('error'); }
  };
  load();
  document.addEventListener('yubz:world-change', load);
})();
